import type { ActionsNetwork } from 'shared/store/actions'
import { fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import type { CustomPageItemsShortDTO } from 'shared/types/api'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { displayManageCookies } from 'shared/store/user'
import { queryParam } from 'shared/utils'

type GetState = () => RootState

type ActionCustomPageDataResponse = {
    type: 'PAGE_DATA_CUSTOM_RESPONSE',
    data: {
        content: string
    }
}

type ActionCustomPageMenuItemsResponse = {
    type: 'PAGE_MENU_ITEMS_CUSTOM_RESPONSE',
    data: {
        customPageItemShortDTOS: CustomPageItemsShortDTO
    }
}

const fetchCustomPageData = (route: string) => async (
    dispatch: Dispatch<any>,
    getState: GetState
) => {
    dispatch(
        fetchPageData(
            `${endpoints.pages.custom}/${route}`,
            'PAGE_DATA_CUSTOM_RESPONSE'
        )
    )
    const router = getState().router
    const search = router ? router.location.search : ''
    if (search === `?${queryParam.MANAGE}`) {
        dispatch(displayManageCookies(true))
    }
}

const fetchCustomPageMenuItems = () =>
    fetchPageData(
        endpoints.pages.customItems,
        'PAGE_MENU_ITEMS_CUSTOM_RESPONSE'
    )

export { fetchCustomPageData, fetchCustomPageMenuItems }

export type Action =
    | ActionCustomPageDataResponse
    | ActionCustomPageMenuItemsResponse
    | ActionsNetwork
